import { render, staticRenderFns } from "./allNotice.vue?vue&type=template&id=b6a78dc0&scoped=true"
import script from "./allNotice.vue?vue&type=script&lang=ts"
export * from "./allNotice.vue?vue&type=script&lang=ts"
import style0 from "./allNotice.vue?vue&type=style&index=0&id=b6a78dc0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6a78dc0",
  null
  
)

export default component.exports